import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { CompanyContextService } from './company-context.service';
import { inject } from '@angular/core';

export class CompanyContextInterceptor implements HttpInterceptor {
  readonly #companyContextService: CompanyContextService = inject(
    CompanyContextService
  );

  intercept(req: HttpRequest<unknown>, handler: HttpHandler) {
    const currentCompany = this.#companyContextService.currentCompany();

    if (currentCompany) {
      req = req.clone({
        setHeaders: {
          'X-Company-Id': currentCompany.id,
        },
      });
    }

    return handler.handle(req);
  }
}
